import { CustomNavigate } from "@UI/CustomNavigate"
import { Typography } from "antd"
import './styles.css'

const { Paragraph } = Typography

const LogsHeader = () => {

  return (
    <header>
      <CustomNavigate title={
        <Paragraph
          className='new-edit-collection-template-title'
          ellipsis
        >
          HISTORIAL DE CAMBIOS
        </Paragraph>
      }>
      </CustomNavigate>
    </header>
  )
}

export default LogsHeader
